module.exports = __webpack_public_path__ + "static/media/support.f18f68a5.png";